import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsAddSubGroupModal, singleNotesData, getBCTbRows } from '../../../redux/actions/BookClosure/actionBookClosure';
import ThirdLabelData from './ThirdLabelData';
import AddSubGroupModal from './AddSubGroupModal';

import { formatAmount } from "../../../utils/formatAmount";
import tablecss from "../../../myfin_v2/css/table.module.css"
import commoncss from "../../../myfin_v2/css/common.module.css"

import { reorderSubgroups, getTbDetails } from "../../Services/ApiHandler"

const CategoryBsAndPnl = ({
  headers,
  rows,
  dragData,
  asOnDateFormatted,
  financialYearStartFormatted,
  selectedFilter,
  bookClosureTbId
}) => {
  const dispatch = useDispatch();
  const {
    switchTab2ndTo3rdLabel
  } = useSelector((initialState) => initialState.BookClosureTbcReducer);

  const [addSubGroupRrquirement, setAddSubGroupRrquirement] = useState({
    level: null,
    levelOneName: ""
  })

  const [localRows, setLocalRows] = useState([]);
  
  useEffect(() => {
    setLocalRows(rows);
  }, [rows]);


  useEffect(() => {
    if (selectedFilter) {
      localRows.forEach(row => {
        row.subgroup?.forEach(subGrp => {
          if (subGrp.name === selectedFilter) {
            dispatch(singleNotesData({ subGrp, groupCatName: row.name }));
          }
        });
      });
    }
  }, [selectedFilter]);

  return (
    <>
      <div className={tablecss.tableContainer} style={{ height: "-webkit-available", overflowY: "auto" }} >
        {
          switchTab2ndTo3rdLabel ? (
            <ThirdLabelData dragData={dragData} asOnDateFormatted={asOnDateFormatted} financialYearStartFormatted={financialYearStartFormatted}/>
          )
            :
            <table className={tablecss.customTable}>
              <thead>
                <tr className='bg-secondary-400'>
                  {
                    headers.map(header => (
                      <th key={header} > {header} </th>
                    ))
                  }
                </tr>
              </thead>
              <tbody>
                {
                  localRows && localRows.length > 0 &&
                  localRows.map((row, rx) => (
                    <React.Fragment key={rx}>
                      <tr>
                        <td colSpan={4} className={`text-left pl-3 ${commoncss.highlightRow}`}> {row?.name} </td>
                      </tr>
                      {
                        row?.subgroup && row?.subgroup.length > 0 &&
                        row?.subgroup.map((subGrp, sx) => (
                          <React.Fragment key={sx}>
                            <tr
                              key={sx}
                              draggable
                              onDragStart={(e) => {
                                e.dataTransfer.setData("draggedIndex", sx.toString());
                                e.dataTransfer.setData("level1Name", row.name);
                              }}
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={async (e) => {
                                e.preventDefault();

                                const draggedIndex = parseInt(e.dataTransfer.getData("draggedIndex"), 10);
                                const sourceLevel1 = e.dataTransfer.getData("level1Name");
                                const targetLevel1 = row.name;
                                const targetLevel1Id = row._id;

                                if (draggedIndex === sx) return;
                                if (sourceLevel1 !== targetLevel1) return;

                                const newSubgroups = [...row.subgroup];
                                const [movedItem] = newSubgroups.splice(draggedIndex, 1);
                                newSubgroups.splice(sx, 0, movedItem);

                                try {

                                  await reorderSubgroups({ 
                                    bookClosureTbId,
                                    level1Id: targetLevel1Id,
                                    level1: targetLevel1,
                                    subgroups: newSubgroups
                                  });

                                  const response = await getTbDetails(bookClosureTbId);

                                  setLocalRows(response.data.bookClosureTB.grouping);
                                } catch (err) {
                                  console.error("Failed to update order", err);
                                }
                              }}

                            >
                              <td className='text-left pl-3' > {subGrp?.name} </td>
                              <td
                                data-note-name={subGrp.name}
                                className='text-center cursor-pointer custom-common-theme-text-color'
                                onClick={() => {
                                  dispatch(singleNotesData({ subGrp, groupCatName: row?.name }))
                                }}
                              >
                                {subGrp?.notes}
                              </td>
                              <td className='text-right pr-3' > {formatAmount(subGrp?.currentYearAmount)} </td>
                              <td className='text-right pr-3' > {formatAmount(subGrp?.previousYearAmount)} </td>
                            </tr>

                            {
                              sx === (row?.subgroup.length - 1) &&
                              <tr>
                                <td
                                  colSpan={4}
                                  className={`text-left pl-3 cursor-pointer ${commoncss.primaryLable}`}
                                  onClick={() => {
                                    setAddSubGroupRrquirement(prev => ({...prev, level:subGrp?.level, levelOneName: row?.name}))
                                    dispatch(setIsAddSubGroupModal(true));
                                  }}
                                >
                                  + Add sub group
                                </td>
                              </tr>
                            }
                          </React.Fragment>
                        ))
                      }

                    </React.Fragment>
                  ))
                }
              </tbody>
            </table>
        }
      </div>
      <AddSubGroupModal 
        requirements={addSubGroupRrquirement} 
        setRequirements={() => setAddSubGroupRrquirement({...addSubGroupRrquirement, level:null, levelOneName:""})} 
      />
    </>
  )
}

export default CategoryBsAndPnl